// extracted by mini-css-extract-plugin
export default {"container":"CheckAuthLoadingPage_container__agwQ0","logoContainer":"CheckAuthLoadingPage_logoContainer__7ZuoL","spin":"CheckAuthLoadingPage_spin__HqJP7"};